import React from 'react';
import s from './index.module.css';

const MessagesCounter = ({ count }) => {
    return (
        <span className={s.counter}>{count}</span>
    );
};

export default MessagesCounter;
